import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import Home from '../views/Home.vue'
import Login from '../views/Auth/Login.vue'
import UserDetail from '../views/UserDetail'

import guest from './middleware/guest'
import auth from './middleware/auth'
import middlewarePipeline from './middlewarePipeline'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { layout: 'guest', middleware: [guest]  }
    },
    {
      path: '/user-detail/:id',
      name: 'user-detail',
      component: UserDetail
    }
  ]
})

router.beforeEach((to, from, next) => {
  let middleware = to.meta.middleware
  if (!to.meta.middleware) {
    middleware = [auth]
  }

  const context = {
    to,
    from,
    next,
    store
  }


  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })

})

export default router
